export default __webpack_public_path__ + "static/media/purple_cross.c1e1d53a.svg";